import * as React from "react";

export type AiMicroBtnProps = {
  title: string;
  "aria-label"?: string;
  disabled?: boolean;
  active?: boolean;
  onClick?: () => void;
  children: React.ReactNode;
  className?: string;
};

/** Compact 22×22 icon button for detail toolbars. */
export const AiMicroBtn: React.FC<AiMicroBtnProps> = ({
  title,
  "aria-label": ariaLabel,
  disabled,
  active,
  onClick,
  children,
  className,
}) => (
  <button
    type="button"
    className={`ai-micro-btn${active ? " is-active" : ""}${className ? ` ${className}` : ""}`}
    title={title}
    aria-label={ariaLabel ?? title}
    disabled={disabled}
    onClick={onClick}
  >
    {children}
  </button>
);

export default AiMicroBtn;
